import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { UserProvider } from './contexts/UserContext';
import { SystemProvider } from './contexts/SystemContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import './App.css';

// 直接导入关键页面 - 提升切换速度
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import EmployeeManagement from './pages/EmployeeManagement';
import DeviceManagement from './pages/DeviceManagement';
import BasicSettings from './pages/BasicSettings';
import About from './pages/About';
import ShippingStationManagement from './pages/ShippingStationManagement';
import ConsignerManagement from './pages/ConsignerManagement';
import CarrierManagement from './pages/CarrierManagement';
import LogisticsOrderManagement from './pages/LogisticsOrderManagement';
import NewLogisticsOrder from './pages/NewLogisticsOrder';


function App() {
  dayjs.locale('zh-cn');
  return (
    <ConfigProvider locale={zhCN}>
      <UserProvider>
        <SystemProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="employees" element={<EmployeeManagement />} />
                <Route path="system-settings/basic-settings" element={<BasicSettings />} />
                <Route path="system-settings/device-management" element={<DeviceManagement />} />
                <Route path="devices" element={<DeviceManagement />} />
                <Route path="about" element={<About />} />
                <Route path="shipping-stations" element={<ShippingStationManagement />} />
                <Route path="consigners" element={<ConsignerManagement />} />
                <Route path="carriers" element={<CarrierManagement />} />
                <Route path="logistics/orders" element={<LogisticsOrderManagement />} />
                <Route path="logistics/new-order" element={<NewLogisticsOrder />} />
              </Route>
            </Routes>
          </Router>
        </SystemProvider>
      </UserProvider>
    </ConfigProvider>
  );
}

export default App;
